<template>
  <div name="hres6oe-checkin" class="hres6oe-checkin">
    <div class="data-loading infinite-loading-container animated fadeIn" :class="[flgLoading ? '-show' : '-hide']"><i class="loading-wave-dots"></i></div>
    <work-place v-show="placeDisp"
                :label="labels[app.nowLang]"
                :workPlace="workPlaceData"
                :toggle="toggle"
                :startFlgLoading="startFlgLoading"
                :stopFlgLoading="stopFlgLoading"
                :lastCheckIn="lastCheckIn"
                :center="center"
                :app="app"
                :setPathImage="setPathImage"
                :receivedCheckInHistory="receivedCheckInHistory"
                :receivedCheckInPlace="receivedCheckInPlace"
                :receivedDataInRaius="receivedDataInRaius"
                :dataInRadius="dataInRadius"
                :getMeLocation="getMeLocation"
                :stopInterval="stopInterval"
                :scrollTop="scrollTop"
                :saveCheckInLog="saveCheckInLog"
                :clearFilterLocation="clearFilterLocation"
                :selectedCompanyCheckin="selectedCompanyCheckin"
                :setSelectedCompanyCheckin="setSelectedCompanyCheckin" />
    <check-in-out v-show="detailDisp"
                  :label="labels[app.nowLang]"
                  :toggle="toggle"
                  :dropdowns="dropdowns.codreason[app.nowLang]"
                  :lastCheckIn="lastCheckIn"
                  :currentUser="app.currentUser"
                  :saveCheckIn="saveCheckIn"
                  :placeNewLatLng="placeNewLatLng"
                  :placeNewLatLngColumns="columns[app.nowLang].custNewLatLng"
                  :setCustNewLatLngSelected="setCustNewLatLngSelected"
                  :setPlaceNewLatLng="setPlaceNewLatLng"
                  :custNewLatLngSelected="custNewLatLngSelected"
                  :workPlaceData="workPlaceData"
                  :center="center"
                  :pathImage="pathImage"
                  :detailDisp="detailDisp"
                  :pcDisp="pcDisp"
                  :scrollTop="scrollTop"
                  :receivedCheckInPlaceNoLocation="receivedCheckInPlaceNoLocation"
                  :flgClearFilterLocation="flgClearFilterLocation"
                  :holdFilterLocation="holdFilterLocation"
                  :selectedCompanyCheckin="selectedCompanyCheckin"
                  :setSelectedCompanyCheckin="setSelectedCompanyCheckin" />
    <history-in-out v-show="historyDisp"
                    :data="history"
                    :label="labels[app.nowLang]"
                    :toggle="toggle"
                    :setHistorySelected="setHistorySelected"
                    :nowLang="app.nowLang"
                    :pcDisp="pcDisp"
                    :scrollTop="scrollTop" />
    <history-detail v-show="hisDetailDisp"
                    :data="historySelected"
                    :label="labels[app.nowLang]"
                    :toggle="toggle"
                    :dropdowns="dropdowns.codreason[app.nowLang]"
                    :currentUser="app.currentUser"
                    :saveCheckInDetail="saveCheckInDetail"
                    :pathImage="pathImage"
                    :pcDisp="pcDisp" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6oe/mutation-types'
import workPlace from 'components/hres6oe/workPlace'
import checkInOut from 'components/hres6oe/checkInOut'
import historyInOut from 'components/hres6oe/historyInOut'
import historyDetail from 'components/hres6oe/historyDetail'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres6oe-checkin',
  data () {
    return {
      app: this.$root.$children[0],
      center: {
        lat: 0,
        lng: 0,
        accuracy: 0
      },
      countFindLocation: 0,
      flgFoundLocation: false,
      intervalLocation: '',
      objGeoErrorMessage: [],
      maxRound: 60,
      flgClearFilterLocation: false,
      selectedCompanyCheckin: -2
    }
  },
  created () {
    this.receivedCheckInColumnsLabels()
    this.receivedCheckInDropdowns()
    this.receivedLastCheckIn(this.app.currentUser.p_codempid)
    this.getMeLocation()
  },
  watch: {
    countFindLocation () {
      if (this.flgFoundLocation) {
        this.stopInterval()
      }
      if (this.countFindLocation >= this.maxRound) {
        this.stopInterval()
      }
      if (this.countFindLocation === 10 || this.countFindLocation === this.maxRound) {
        let geoErrorMessage = ''
        let concat = '<br>'
        this.objGeoErrorMessage.forEach(function (value, index) {
          if (value !== '') {
            geoErrorMessage += concat + '( code: ' + index + ') ' + value
          }
        })
        console.warn('geolocation error !!!', this.objGeoErrorMessage)
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR9001') + geoErrorMessage,
          confirmButtonText: constLabels('ok'),
          html: true
        })
      }
    },
    'center.lat' () {
      if (this.center.lat !== '') {
        swal.close()
      }
    },
    'center.lng' () {
      if (this.center.lat !== '') {
        swal.close()
      }
    },
    flgFoundLocation () {
      if (this.flgFoundLocation) {
        this.stopInterval()
        this.receivedCheckInPlace(this.center)
      }
    }
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    },
    ...mapGetters({
      columns: types.GET_CHECKIN_COLUMNS,
      placeDisp: types.GET_CHECKIN_PLACE_DISP,
      historyDisp: types.GET_CHECKIN_HISTORY_DISP,
      hisDetailDisp: types.GET_CHECKIN_HIS_DETAIL_DISP,
      detailDisp: types.GET_CHECKIN_DETAIL_DISP,
      labels: types.GET_CHECKIN_LABELS,
      workPlaceData: types.GET_CHECKIN_PLACE,
      placeNewLatLng: types.GET_CHECKIN_PLACE_NEW_LATLNG,
      history: types.GET_CHECKIN_HISTORY,
      dropdowns: types.GET_CHECKIN_DROPDOWNS,
      dataInRadius: types.GET_CHECKIN_DATA_IN_RADIUS,
      historySelected: types.GET_CHECKIN_HIS_SELECTED,
      lastCheckIn: types.GET_LAST_CHECKIN,
      custNewLatLngSelected: types.GET_CHECKIN_NEW_LAT_LNG_SELECTED,
      pathImage: types.GET_CHECKIN_PATH_IMAGE,
      flgLoading: types.GET_FLG_LOADING
    })
  },
  methods: {
    ...mapMutations({
      setHistorySelected: types.SET_CHECKIN_HIS_SELECTED,
      setCustNewLatLngSelected: types.SET_CHECKIN_NEW_LAT_LNG_SELECTED,
      setPlaceNewLatLng: types.SET_CHECKIN_PLACE_NEW_LATLNG,
      setPathImage: types.SET_CHECKIN_PATH_IMAGE
    }),
    ...mapActions({
      toggle: types.TOGGLE_CHECKIN_PAGE,
      startFlgLoading: types.START_FLG_LOADING,
      stopFlgLoading: types.STOP_FLG_LOADING,
      receivedCheckInColumnsLabels: types.RECEIVED_CHECKIN_COLUMNS_LABELS,
      receivedCheckInPlace: types.RECEIVED_CHECKIN_PLACE,
      receivedCheckInPlaceNoLocation: types.RECEIVED_CHECKIN_PLACE_NO_LOCATION,
      receivedCheckInHistory: types.RECEIVED_CHECKIN_HISTORY,
      receivedCheckInDropdowns: types.RECEIVED_CHECKIN_DROPDOWNS,
      receivedLastCheckIn: types.RECEIVED_LAST_CHECKIN,
      receivedDataInRaius: types.RECEIVED_CHECKIN_DATA_IN_RADIUS,
      saveCheckIn: types.SAVE_CHECKIN,
      saveCheckInDetail: types.SAVE_CHECKIN_DETAIL,
      saveCheckInLog: types.SAVE_CHECKIN_LOG
    }),
    stopInterval () {
      clearInterval(this.intervalLocation)
    },
    errorGeoCallback (error) {
      this.objGeoErrorMessage[error.code] = error.message
      this.flgFoundLocation = false
      swal.close()
    },
    successGeoCallback (position) {
      if (position !== '') {
        let coords = position.coords
        this.center.lat = parseFloat(coords.latitude.toFixed(8))
        this.center.lng = parseFloat(coords.longitude.toFixed(8))
        this.center.accuracy = (coords.accuracy / 1000).toFixed(2)
        this.flgFoundLocation = true
        swal.close()
      } else {
        this.flgFoundLocation = false
      }
    },
    getMeLocation () {
      let options = {
        enableHighAccuracy: true,
        timeout: 600000, // 10 mins
        maximumAge: 0
      }
      let _this = this
      this.countFindLocation = 0
      this.stopInterval()
      this.flgFoundLocation = false
      swal({title: '', text: '<br>' + constLabels('msgFindingLocation') + '<div class="infinite-loading-container"><i class="loading-wave-dots"></i></div>', type: 'info', html: true, showConfirmButton: false})
      this.intervalLocation = setInterval(function () {
        _this.countFindLocation++
        navigator.geolocation.getCurrentPosition(_this.successGeoCallback, _this.errorGeoCallback, options)
      }, 1000)
      // navigator.geolocation.getCurrentPosition(this.successGeoCallback, this.errorGeoCallback, options)
      // navigator.geolocation.watchPosition(this.successGeoCallback, this.errorGeoCallback, options)
    },
    scrollTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    clearFilterLocation () {
      this.flgClearFilterLocation = true
    },
    holdFilterLocation () {
      this.flgClearFilterLocation = false
    },
    setSelectedCompanyCheckin (index) {
      this.selectedCompanyCheckin = index
    }
  },
  components: {
    workPlace,
    checkInOut,
    historyInOut,
    historyDetail
  }
}
</script>

<style src="components/hres6oe/style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// component.vue?07ea3d2a